// extracted by mini-css-extract-plugin
module.exports = {"form":"Login_form__3GPY_","logTitulo":"Login_logTitulo__lDqB5","opcaoLogin":"Login_opcaoLogin__2jbkz","msgLogin":"Login_msgLogin__7wkkz"};